import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getVideoContentTemplateRequest, getVideoDetailRequest, getVideoEmojiRequest, getRestrictedKeywordRequest, getTimeVideoRenderRequest } from "./../../../pages/Video/redux/actions"

export const useVideoDetail = (params) => {
  const dispatch = useDispatch();
  const {videoDetail, isProcessing} = useSelector((state) => state.videoDetailReducers);
  useEffect(() => {
    console.log(params, 'paramsparamsparams');
    dispatch(getVideoDetailRequest(params));
  }, [params, dispatch, getVideoDetailRequest]);

  return [videoDetail, isProcessing]
};

export const useVideoTemplate = (params) => {
  
  const dispatch = useDispatch();
  const {videoTemplate} = useSelector((state) => state.videoDetailReducers);
  useEffect(() => {
    dispatch(getVideoContentTemplateRequest(params));
  }, [params,dispatch, getVideoContentTemplateRequest]);
  
  return [videoTemplate]
};

export const useRestrictedKeywords = (params) => {
  
  const dispatch = useDispatch();
  const {restrictedKeyword} = useSelector((state) => state.videoDetailReducers);
  useEffect(() => {
    dispatch(getRestrictedKeywordRequest(params));
  }, [params,dispatch, getRestrictedKeywordRequest]);
  
  return [restrictedKeyword]
};

export const useVideoEmoji = (params) => {
  
  const dispatch = useDispatch();
  const {videoEmoji, isProcessingEmoji} = useSelector((state) => state.videoEmojiReducers);
  useEffect(() => {
    dispatch(getVideoEmojiRequest(params));
  }, [params, dispatch, getVideoEmojiRequest]);
  
  return [videoEmoji, isProcessingEmoji]
};


export const useVideoRender = (params) => {
  
  const dispatch = useDispatch();
  const {videoRender, isProcessingVideoRender} = useSelector((state) => state.videoDetailReducers);
  useEffect(() => {
    dispatch(getTimeVideoRenderRequest(params));
  }, [params,dispatch, getTimeVideoRenderRequest]);
  
  return [videoRender, isProcessingVideoRender]
};